module.exports = __webpack_public_path__ + "static/media/check.fb815f95.svg";